import { FC, useEffect } from 'react';
import { Box, VStack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import PasscodeInput from 'components/PasscodeInput';
import StepperProgressBar from 'components/Stepper/StepperProgressBar';
import { StepProps } from 'components/Stepper/types';
import * as Layout from 'layouts/StepperLayout';

import { CtaButton } from '../../../components/Buttons';
import { usePhysicalCardOrderFlowContext } from '../../hooks/usePhysicalCardOrderFlowContext';
import ToggleShowPasscode from '../PhysicalCardOrderCardPin/components/ToggleShowPasscode';
import locales from './locales';

const PhysicalCardOrderCardPin: FC<StepProps> = (props) => {
  const { goBack, goNext } = props;

  const { setSharedState, sharedState } = usePhysicalCardOrderFlowContext();
  const { isPasscodeShown } = sharedState;

  const setPinConfirmationWasDifferent = (value: boolean) => {
    setSharedState({ ...sharedState, pinConfirmationWasDifferent: value });
  };

  useEffect(() => {
    setPinConfirmationWasDifferent(false);
    // We want to reset the error state on the first render only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNext = (pinCodeConfirm: string) => {
    if (pinCodeConfirm !== sharedState.pin) {
      setPinConfirmationWasDifferent(true);
      goBack();
      return;
    }

    goNext({ shouldReplaceCurrentStep: true });
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={goBack} />
        </Layout.HeaderButtonsContainer>

        <Layout.BodyScrollableSection>
          <VStack alignItems="stretch" spacing="space-8">
            <Heading size="lg">{locales.title}</Heading>
            <Text size="lg">{locales.subtitle}</Text>
          </VStack>

          <Box marginTop="space-32">
            <PasscodeInput hidden={!isPasscodeShown} onSubmit={handleNext} />
          </Box>

          <Box marginTop="space-32">
            <ToggleShowPasscode />
          </Box>
        </Layout.BodyScrollableSection>

        <Layout.FooterContainer>
          <StepperProgressBar />
          <Layout.FooterButtonsContainer>
            <CtaButton isDisabled>{locales.next}</CtaButton>
          </Layout.FooterButtonsContainer>
        </Layout.FooterContainer>
      </Layout.Body>
    </Layout.Root>
  );
};

export default PhysicalCardOrderCardPin;
